import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';

// core components
import SweetAlert from 'components/SweetModal/SweetAlert';
import GridContainer from 'components/Grid/GridContainer';
import ItemGrid from 'components/Grid/ItemGrid';
import ProfileCard from 'components/Cards/ProfileCard';
import Button from 'components/CustomButtons/Button';
import CustomInput from 'components/CustomInput/CustomInput';
import ErrorBoundaries from 'components/Wrapper/ErrorBoundaries';
// @material-ui/icons
import LockOutlined from '@material-ui/icons/LockOutlined';

// helper / style / config
import config from 'config';
import { verifyLength, compare } from 'helpers/helpers';
import { parse } from 'helpers/query-string';
import ForgotPasswordPageStyle from 'views/Auth/style/forgotPasswordPageStyle';

class NewPasswordPage extends React.Component {
  // we use this to make the card to appear after the page has been rendered
  state = {
    successAlert: null,
    warningAlert: null,
    password: '',
    passwordState: '',
    confirmPassword: '',
    confirmPasswordState: '',
    // sweetAlert
    errorMessage: '',
  };

  change(event, stateName, type, stateNameEqualTo) {
    switch (type) {
      case 'password':
        if (verifyLength(event.target.value, 6)) {
          this.setState({ [`${stateName}State`]: 'success' });
        } else {
          this.setState({ [`${stateName}State`]: 'error' });
        }
        break;
      case 'equalTo':
        if (compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({ [`${stateName}State`]: 'success' });
        } else {
          this.setState({ [`${stateName}State`]: 'error' });
        }
        break;
      default:
        break;
    }

    this.setState({ [stateName]: event.target.value });
  }

  registerClick = (e, token) => {
    e.preventDefault();

    if (this.state.passwordState === '') {
      this.setState({ passwordState: 'error' });
    }
    if (this.state.confirmPasswordState === '') {
      this.setState({ confirmPasswordState: 'error' });
    }

    if (this.state.passwordState === 'success' && this.state.confirmPasswordState === 'success') {
      axios
        .post(`${config.API_URL}/public/auth/reset_password`, {
          token,
          password: this.state.password,
        })
        .then(() => {
          this.successAlert();
        })
        .catch((error) => {
          const errorMessage =
            error.response && error.response.data && error.response.data.message ? error.response.data.message : '';
          this.warningAlert(errorMessage);
        });
    }
  };

  warningAlert = (errorMessage) => {
    this.setState({ warningAlert: true, errorMessage });
    setTimeout(this.warningRedirect, 4000);
  };

  successAlert = () => {
    this.setState({
      email: '',
      successAlert: true,
    });
    setTimeout(this.successRedirect, 4000);
  };

  warningRedirect = () => {
    this.props.history.push('/auth/mot-de-passe');
  };

  successRedirect = () => {
    this.props.history.push('/auth/connexion');
  };

  render() {
    const { classes } = this.props;
    const { warningAlert, successAlert, errorMessage } = this.state;
    const query = parse(this.props.location.search);

    return (
      <ErrorBoundaries>
        <Fragment>
          {warningAlert && (
            <SweetAlert
              warning
              title='Huston, on a eu un problème !'
              onConfirm={this.warningRedirect}
              confirmBtnText='Ok'
              text={`Nous n'avons pas pu définir votre nouveau mot de passe. Veuillez
          recommencer la procédure. ${errorMessage}`}
            />
          )}
          {successAlert && (
            <SweetAlert
              success
              title='Votre nouveau mot de passe est confirmé'
              onConfirm={this.successRedirect}
              confirmBtnText='Ok'
              text='Vous allez être redirigé vers la page de connexion'
            />
          )}
          <div className={classes.content}>
            <GridContainer justifyContent='center'>
              <ItemGrid xs={12} sm={6} md={4} lg={3}>
                <form onSubmit={(e) => this.registerClick(e, query.token)}>
                  <ProfileCard
                    customCardClass={`${classes.customCardClass} ${classes.card}`}
                    customCardAvatarClass={classes.customCardAvatarClass}
                    customCardFooterClass={classes.customCardFooterClass}
                    customCardTitleClass={classes.customCardTitleClass}
                    title='Définir votre mot de passe'
                    avatar={query.picture ? query.picture : null}
                    content={
                      <div>
                        <CustomInput
                          success={this.state.passwordState === 'success'}
                          error={this.state.passwordState === 'error'}
                          labelText='Mot de passe *'
                          id='password'
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: 'password',
                            startAdornment: (
                              <InputAdornment position='start'>
                                <LockOutlined className={classes.inputAdornmentIcon} />
                              </InputAdornment>
                            ),
                            onChange: (event) => this.change(event, 'password', 'password'),
                          }}
                        />
                        <CustomInput
                          success={this.state.confirmPasswordState === 'success'}
                          error={this.state.confirmPasswordState === 'error'}
                          labelText='Confirmez le mot de passe *'
                          id='confirmPassword'
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: 'password',
                            startAdornment: (
                              <InputAdornment position='start'>
                                <LockOutlined className={classes.inputAdornmentIcon} />
                              </InputAdornment>
                            ),
                            onChange: (event) => this.change(event, 'confirmPassword', 'equalTo', 'password'),
                          }}
                        />
                      </div>
                    }
                    footer={
                      <Button color='primary' type='submit'>
                        Valider
                      </Button>
                    }
                  />
                </form>
              </ItemGrid>
            </GridContainer>
          </div>
        </Fragment>
      </ErrorBoundaries>
    );
  }
}

NewPasswordPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(ForgotPasswordPageStyle)(NewPasswordPage);
